const forEachInTree = (items, callback, parent = null) => {
  items.forEach((item, index) => {
    callback(item, index, parent)
    if (Array.isArray(item.items) && item.items.length) {
      forEachInTree(item.items, callback, item)
    }
  })
}

const buildTree = (itemsAsObject, viewport = 'desktop', section = null, parentId = null) => {
  return Object.values(itemsAsObject)
    .filter(item => item.parent_id === parentId)
    .sort((a, b) => {
      const ao = a.viewport[viewport].order ?? 0
      const bo = b.viewport[viewport].order ?? 0

      return ao - bo
    })
    .map(item => {
      return {
        ...item,
        items: buildTree(itemsAsObject, viewport, section, item.id),
      }
    })
}

const buildVisibleTree = (itemsAsObject, viewport = 'desktop', section = null, parentId = null) => {
  return Object.values(itemsAsObject)
    .filter(item => item.parent_id === parentId)
    .filter(item => item.viewport[viewport].visible === true)
    .sort((a, b) => {
      const ao = a.viewport[viewport].order ?? 0
      const bo = b.viewport[viewport].order ?? 0

      return ao - bo
    })
    .map(item => {
      return {
        ...item,
        items: buildVisibleTree(itemsAsObject, viewport, section, item.id),
      }
    })
}

export {
  buildTree,
  buildVisibleTree,
  forEachInTree,
}
